const ContactInfo = () => {
  return (
    <div className="space-y-8 animate-slide-up">
      <div className="bg-white p-8 rounded-sm shadow-lg">
        <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
          Información de Contacto
        </h3>
        
        <div className="space-y-6">
          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-map-pin-line text-2xl text-[#ffb7b4]"></i>
            </div>
            <div>
              <h4 className="font-medium text-[#3a3a3a] mb-1">Dirección</h4>
              <p className="text-[#3a3a3a]/80">
                Paseo de la Independencia 25<br />
                50001 Zaragoza, España
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-mail-line text-2xl text-[#ffb7b4]"></i>
            </div>
            <div>
              <h4 className="font-medium text-[#3a3a3a] mb-1">Email</h4>
              <a 
                href="mailto:contacto@alttatalentstudio.com" 
                className="text-[#3a3a3a]/80 hover:text-[#ffb7b4] transition-colors cursor-pointer"
              >
                contacto@alttatalentstudio.com
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-phone-line text-2xl text-[#ffb7b4]"></i>
            </div>
            <div>
              <h4 className="font-medium text-[#3a3a3a] mb-1">Teléfono</h4>
              <a 
                href="tel:+34644221998" 
                className="text-[#3a3a3a]/80 hover:text-[#ffb7b4] transition-colors cursor-pointer"
              >
                +34 644 221 998
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-8 rounded-sm shadow-lg">
        <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
          Horario de Atención
        </h3>
        
        <div className="space-y-3 text-[#3a3a3a]/80">
          <div className="flex justify-between">
            <span>Lunes - Viernes</span>
            <span>9:00 - 18:00</span>
          </div>
          <div className="flex justify-between">
            <span>Sábados</span>
            <span>10:00 - 14:00</span>
          </div>
          <div className="flex justify-between">
            <span>Domingos</span>
            <span>Cerrado</span>
          </div>
        </div>
      </div>

      <div className="bg-white p-8 rounded-sm shadow-lg">
        <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
          Ubicación
        </h3>
        
        <div className="aspect-video rounded overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2985.5667!2d-0.8891!3d41.6488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDM4JzU1LjciTiAwwrA1MycyMC44Ilc!5e0!3m2!1ses!2ses!4v1635789012345!5m2!1ses!2ses"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación de Altta Talent Studio en Zaragoza"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;